module.exports = __webpack_public_path__ + "geoCompassPlus_dark.ff0cec9983677ec495987fb7c198663f.png";